import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/LoginForm';
import ContentEditor from '../components/admin/ContentEditor';
import GalleryManager from '../components/admin/GalleryManager';
import ReviewsManager from '../components/admin/ReviewsManager';

const F = "'Inter', system-ui, sans-serif";

const TABS = [
  { id: 'content', label: 'Seiteninhalte', icon: '📝' },
  { id: 'gallery', label: 'Galerie', icon: '🖼️' },
  { id: 'reviews', label: 'Bewertungen', icon: '⭐' },
];

export default function AdminPage() {
  const { isLoggedIn, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('content');

  if (!isLoggedIn) return <LoginForm />;

  const active = TABS.find(t => t.id === activeTab);

  return (
    <div style={styles.layout}>
      <aside style={styles.sidebar}>
        <div style={styles.brand}>
          <span style={styles.brandIcon}>🏕️</span>
          <div>
            <p style={styles.brandName}>Camping Spirkenhof</p>
            <p style={styles.brandSub}>Admin-Bereich</p>
          </div>
        </div>

        <nav style={styles.nav}>
          {TABS.map(tab => (
            <button
              key={tab.id}
              style={{ ...styles.navBtn, ...(activeTab === tab.id ? styles.navBtnActive : {}) }}
              onClick={() => setActiveTab(tab.id)}
            >
              <span style={styles.navIcon}>{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>

        <div style={styles.sidebarFooter}>
          <button style={styles.logoutBtn} onClick={logout}>↩ Abmelden</button>
        </div>
      </aside>

      <main style={styles.main}>
        <div style={styles.mainHeader}>
          <h1 style={styles.mainTitle}>{active.icon} {active.label}</h1>
        </div>
        <div style={styles.mainContent}>
          {activeTab === 'content' && <ContentEditor />}
          {activeTab === 'gallery' && <GalleryManager />}
          {activeTab === 'reviews' && <ReviewsManager />}
        </div>
      </main>
    </div>
  );
}

const styles = {
  layout: {
    display: 'flex',
    minHeight: 'calc(100vh - 62px)',
    backgroundColor: '#f8f9fa',
  },
  sidebar: {
    width: '230px',
    flexShrink: 0,
    backgroundColor: 'white',
    borderRight: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    top: '62px',
    height: 'calc(100vh - 62px)',
    overflowY: 'auto',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '1.5rem 1.25rem',
    borderBottom: '1px solid #f3f4f6',
  },
  brandIcon: { fontSize: '1.6rem', lineHeight: 1 },
  brandName: { fontFamily: F, fontWeight: '700', fontSize: '0.85rem', color: '#111827', margin: 0 },
  brandSub: { fontFamily: F, fontSize: '0.72rem', color: '#9ca3af', margin: '0.15rem 0 0' },

  nav: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem 0.75rem',
    gap: '0.2rem',
    flex: 1,
  },
  navBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.65rem',
    padding: '0.65rem 0.9rem',
    borderRadius: '8px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontFamily: F,
    fontSize: '0.9rem',
    color: '#374151',
    fontWeight: '500',
    textAlign: 'left',
    width: '100%',
  },
  navBtnActive: {
    backgroundColor: '#f0fdf4',
    color: '#1e8449',
    fontWeight: '600',
  },
  navIcon: { fontSize: '1rem', flexShrink: 0 },

  sidebarFooter: {
    padding: '1rem 0.75rem',
    borderTop: '1px solid #f3f4f6',
  },
  logoutBtn: {
    width: '100%',
    padding: '0.6rem 0.9rem',
    backgroundColor: 'transparent',
    color: '#dc3545',
    border: '1px solid #fca5a5',
    borderRadius: '8px',
    cursor: 'pointer',
    fontFamily: F,
    fontSize: '0.875rem',
    fontWeight: '500',
    textAlign: 'left',
  },

  main: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  mainHeader: {
    backgroundColor: 'white',
    borderBottom: '1px solid #e5e7eb',
    padding: '1.25rem 2rem',
  },
  mainTitle: {
    fontFamily: F,
    fontSize: '1.2rem',
    fontWeight: '700',
    color: '#111827',
    margin: 0,
  },
  mainContent: {
    padding: '2rem',
    flex: 1,
  },
};
